import { render, staticRenderFns } from "./ClassUploadItem.vue?vue&type=template&id=48fe01ba&scoped=true&"
import script from "./ClassUploadItem.vue?vue&type=script&lang=js&"
export * from "./ClassUploadItem.vue?vue&type=script&lang=js&"
import style0 from "./ClassUploadItem.vue?vue&type=style&index=0&id=48fe01ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48fe01ba",
  null
  
)

export default component.exports